import { CustomPIXIComponent } from 'react-pixi-fiber'
import { findTexture } from 'mc_pixi-fiber'
import { Container, Sprite, Texture } from 'pixi.js'
import { Loader } from "pixi.js"
const { resources } = Loader.shared

import RocketStage from "./RocketStage"
import ParticleSystem from "./ParticleSystem"
import LaunchProfiles from "./launchProfiles"
import Timings from "game/Timings"
import { flagSize, flagPositions } from "./Flags"

const {
    ROCKET_STAGE_DRIFT_DURATION,
    ROCKET_STAGE_SEPARATION_DELAY,
    ROCKET_STAGE_SEPARATION_DURATION
} = Timings

const PARTICLE_SYSTEM_HEIGHT_SCALE = 0.945

class Rocket extends Container {
    constructor(props) {
        super(props);

        const { resolution } = props

        const textures = [
            findTexture("rocket/rocket_01"),
            findTexture("rocket/rocket_02"),
            findTexture("rocket/rocket_03")
        ]

        const heights = textures.map((texture) => {
            return texture.orig.height
        })

        const rocketHeight = heights.reduce((sum, height) => {
            return sum + height
        }, 0)

        const rocketWidth = textures.reduce((sum, texture) => {
            const width = texture.orig.width
            return width > sum ? width : sum
        }, 0)

        const offsets = [0, -11, -15] //hide the boosters for the second and third stage while the rocket is joined

        const stages = textures.map((texture, index) => {
            const x = 0
            const y = heights.reduce((sum, height, heightIndex) => {
                const offset = offsets[heightIndex]

                if (heightIndex <= index) {
                    return sum + ((height + offset) / resolution)
                }

                return sum
            }, 0)

            const stage = new RocketStage(texture, resolution)
            stage.position.set(x, y)
            return stage
        })

        const launchExhaust = new ParticleSystem("launchExhaust", ["particles/smoke"])
        this.launchExhaust = launchExhaust

        const mainThruster = new ParticleSystem(["mainThrusterExhaust", "mainThruster"], [["particles/smoke"], ["particles/particle"]])
        this.mainThruster = mainThruster

        const launchPositions = [] //save the lauch positions for later
        stages.forEach((stage, index) => {
            launchPositions[index] = {
                x: stage.x,
                y: stage.y
            }

            this.addChild(stage)
        })

        const launchCoolant = new ParticleSystem("launchCoolant", ["particles/particle"])
        this.launchCoolant = launchCoolant

        this.rocketWidth = rocketWidth
        this.rocketHeight = rocketHeight

        this.thirdStage = stages[0]
        this.secondStage = stages[1]
        this.firstStage = stages[2]

        this.heights = heights
        this.offsets = offsets
        this.resolution = resolution

        this.launchProfiles = new LaunchProfiles(this)

        const resetToLaunchPositions = () => {
            this.zoom = resolution

            this.launchProfiles.stopTweens()

            launchCoolant.stop()
            launchExhaust.stop()
            mainThruster.stop()

            launchCoolant.y = rocketHeight * (PARTICLE_SYSTEM_HEIGHT_SCALE / resolution)
            launchExhaust.y = rocketHeight * (PARTICLE_SYSTEM_HEIGHT_SCALE / resolution)
            mainThruster.y = rocketHeight * (PARTICLE_SYSTEM_HEIGHT_SCALE / resolution)

            this.removeChildren()

            this.addChild(launchExhaust)
            this.addChild(mainThruster)

            stages.forEach((stage, index) => {
                stage.stopThruster()
                const position = launchPositions[index]
                stage.position.set(position.x, position.y)
                stage.rotation = 0
                this.addChild(stage)
            })
            this.addChild(launchCoolant)
        }

        resetToLaunchPositions()
        this.resetToLaunchPositions = resetToLaunchPositions

        const flagPosition = flagPositions[props.country]
        //only add a flag if we have it
        if (flagPosition) {
            const flagFrame = {
                x: flagPosition.x,
                y: flagPosition.y,
                width: flagSize.width,
                height: flagSize.height
            }

            const flagTexture = new Texture(resources["flags"].texture.baseTexture, flagFrame)
            const flag = new Sprite(flagTexture)
            flag.anchor.set(0.5)
            flag.scale.set(0.45)
            flag.y = this.thirdStage.height * -0.6
            this.thirdStage.addChild(flag)
        }
    }

    update(props) {
        const { x, y, width, height, resolution } = props
        const { rocketWidth, rocketHeight } = this
        this.props = props

        const rocketRatio = rocketWidth / rocketHeight
        const scaledHeight = height
        const scaledWidth = scaledHeight * rocketRatio

        this.position.set(x, y)
        this.scale.set(height / rocketHeight * this.zoom)
        this.mostRecentProps = { x, y, width, height, resolution }
    }

    updateStage(index, instant) {
        switch(index) {
            case 0:
                if (instant) {
                    this.launchProfiles.resumeLaunch()
                }
                break
            case 1:
                this.launchProfiles.ejectFirstStage(instant)
                break
            case 2:
                this.launchProfiles.ejectSecondStage(instant)
                break
            case 3:
                if (instant) {
                    this.launchProfiles.ejectSecondStage(true)
                }
                break
            default:
                this.resetToLaunchPositions()
        }
    }

    startCoolant() {
        this.launchCoolant.start()
    }

    stopCoolant(pauseRendering) {
        this.launchCoolant.stop(pauseRendering)
    }

    launch() {
        this.launchProfiles.launch()
    }

    leaveAtmosphere() {
        this.launchProfiles.leaveAtmosphere()
    }
}

//CUSTOM REACT-PIXI CLASS
export default CustomPIXIComponent({

    customDisplayObject(props) {
        return new Rocket(props)
    },

    customApplyProps(displayObject, oldProps, newProps) {
        displayObject.update(newProps)

        if (newProps.currentPickStageIndex !== oldProps.currentPickStageIndex) {
            displayObject.updateStage(newProps.currentPickStageIndex, newProps.refresh)
        }
    }
}, 'Rocket')
